import ArrowLeftIcon from '@wwt/shared/assets/icons/outline/arrow-left.svg'
import ArrowRightIcon from '@wwt/shared/assets/icons/outline/arrow-right.svg'

import { cn } from '@/shared/lib/cn'

interface NavigationIconProps {
	direction: 'left' | 'right'
	className?: string
}

export const NavigationIcon = ({
	direction,
	className
}: NavigationIconProps) => {
	if (direction === 'left') {
		return (
			<ArrowLeftIcon
				className={cn('mr-[2px] size-6', className)}
				key="navigation-icon"
			/>
		)
	}

	return (
		<ArrowRightIcon
			className={cn('ml-[2px] size-6', className)}
			key="navigation-icon"
		/>
	)
}
